import { render, staticRenderFns } from "./loginHgd.vue?vue&type=template&id=195cb97b&scoped=true&"
import script from "./loginHgd.vue?vue&type=script&lang=js&"
export * from "./loginHgd.vue?vue&type=script&lang=js&"
import style0 from "./loginHgd.vue?vue&type=style&index=0&id=195cb97b&scoped=true&lang=css&"
import style1 from "./loginHgd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195cb97b",
  null
  
)

export default component.exports